import { MINI_GAME_ACTIVE_WINDOW_MS } from './constants';

export const formatClock = (ms: number): string => {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;

  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

export const isActiveSince = (lastActivityAt: number, now: number) =>
  now - lastActivityAt < MINI_GAME_ACTIVE_WINDOW_MS;

export const remainingShare = (
  deadlineAt: number,
  now: number,
  windowMs: number,
) => Math.max(0, Math.min(1, (deadlineAt - now) / windowMs));
